import Distance from 'components/Distance';

export default class LadderDistance {
	static getDistanceFromLocations(location1, location2) {
		if(location1 && location1.hasCoordinates() && location2 && location2.hasCoordinates()) {
			return LadderDistance.getDistanceFromLatLonInMeters(location1.latitude, location1.longitude,
				location2.latitude, location2.longitude);
		}
		return null;
	}

	static getDistanceFromLatLonInMeters(lat1, lon1, lat2, lon2) {
		const deltaLat = lat2 - lat1;
		const deltaLon = lon2 - lon1;
		const earthRadius = 6371000;
		const alpha = deltaLat / 2;
		const beta = deltaLon / 2;
		const a = Math.sin(LadderDistance.deg2rad(alpha)) * Math.sin(LadderDistance.deg2rad(alpha)) + Math.cos(LadderDistance.deg2rad(lat1)) *
			Math.cos(LadderDistance.deg2rad(lat2)) * Math.sin(LadderDistance.deg2rad(beta)) * Math.sin(LadderDistance.deg2rad(beta));
		const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
		const distance = earthRadius * c;
		return new Distance(distance);
	}

	static deg2rad(deg) {
		return deg * (Math.PI / 180);
	}
}